import { fromJS, Map } from 'immutable';
import types from '../constants/emailConstants';

const initialState = {
  data: { data: [], isLoading: true },
  detail: { data: null, isLoading: false, hasError: false },
  lastListQuery: null,
};

const initialImmutableState = fromJS(initialState);
export default function reducer(state = initialImmutableState, action = {}) {
  switch (action.type) {
    case types.GET_EMAIL:
      return state.withMutations((mutableState) => {
        if (action.payload) {
          mutableState.set('lastListQuery', fromJS(action.payload));
        }
        mutableState.updateIn(['data'], (data = Map()) => data.set('isLoading', true));
      });
    case types.SET_EMAIL:
      return state.withMutations((mutableState) => {
        mutableState.set('data', fromJS({ ...action.payload, isLoading: false }));
      });
    case types.GET_EMAIL_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.updateIn(['detail'], (detail = Map()) =>
          detail.merge(fromJS({ isLoading: true, hasError: false })),
        );
      });
    case types.SET_EMAIL_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.set(
          'detail',
          fromJS({ data: action.payload, isLoading: false, hasError: false }),
        );
      });
    case types.SET_EMAIL_DETAIL_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('detail', fromJS({ data: null, isLoading: false, hasError: true }));
      });
    default:
      return state;
  }
}
